"use strict";
exports.__esModule = true;
exports.SymbolFaceSatisfiedIcon = void 0;
var tslib_1 = require("tslib");
/**
 * This file is generated from scripts/genIconComponents.js. Any
 * changes should be made in that file.
 */
var react_1 = tslib_1.__importStar(require("react"));
var utils_1 = require("../../utils");
var icon_1 = require("../../icon");
var SymbolFaceSatisfied_1 = require("./medium/SymbolFaceSatisfied");
var sizeMap = {
    medium: SymbolFaceSatisfied_1.SvgSymbolFaceSatisfied
};
var defaultSize = utils_1.getDefaultSize(sizeMap);
exports.SymbolFaceSatisfiedIcon = react_1.forwardRef(function (_a, ref) {
    var _b = _a.size, size = _b === void 0 ? defaultSize : _b, rest = tslib_1.__rest(_a, ["size"]);
    return (react_1["default"].createElement(icon_1.Icon, tslib_1.__assign({ ref: ref, svgComponent: utils_1.getSvgResourceForSize(sizeMap, size), size: size }, rest)));
});
exports.SymbolFaceSatisfiedIcon.displayName = "SymbolFaceSatisfiedIcon";
//# sourceMappingURL=SymbolFaceSatisfiedIcon.js.map